import e, { Component as o } from "react";
import { getScrollNode as r } from "../../utils/dom/index.js";
import "../../../node_modules/underscore/modules/index-default.js";
import "../../../node_modules/underscore/modules/_setup.js";
import "../../../node_modules/underscore/modules/isFunction.js";
import "../../../node_modules/underscore/modules/_stringTagBug.js";
import "../../../node_modules/underscore/modules/isArguments.js";
import "../../../node_modules/underscore/modules/underscore.js";
import "../../../node_modules/underscore/modules/isMap.js";
import "../../../node_modules/underscore/modules/isWeakMap.js";
import "../../../node_modules/underscore/modules/isSet.js";
import "../../../node_modules/underscore/modules/toPath.js";
import "../../../node_modules/underscore/modules/iteratee.js";
import "../../../node_modules/underscore/modules/escape.js";
import "../../../node_modules/underscore/modules/unescape.js";
import "../../../node_modules/underscore/modules/templateSettings.js";
import "../../../node_modules/underscore/modules/partial.js";
import "../../../node_modules/underscore/modules/bind.js";
import "../../../node_modules/underscore/modules/bindAll.js";
import "../../../node_modules/underscore/modules/delay.js";
import "../../../node_modules/underscore/modules/defer.js";
import t from "../../../node_modules/underscore/modules/throttle.js";
import "../../../node_modules/underscore/modules/once.js";
import "../../../node_modules/underscore/modules/invoke.js";
import "../../../node_modules/underscore/modules/pick.js";
import "../../../node_modules/underscore/modules/omit.js";
import "../../../node_modules/underscore/modules/without.js";
import "../../../node_modules/underscore/modules/union.js";
import "../../../node_modules/underscore/modules/difference.js";
import "../../../node_modules/underscore/modules/zip.js";
import "../../../node_modules/underscore/modules/underscore-array-methods.js";
import { componentName as n } from "../../utils/bem/index.js";
import d from "../../utils/ObjectUtils.js";
function s(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function u(e, o) {
  for (var r = 0; r < o.length; r++) {
    var t = o[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function l(e, o, r) {
  return o in e ? Object.defineProperty(e, o, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = r, e;
}
function i(e) {
  return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function a(e, o) {
  return (a = Object.setPrototypeOf || function (e, o) {
    return e.__proto__ = o, e;
  })(e, o);
}
var c = 50,
  m = 200,
  p = function (o) {
    !function (e, o) {
      if ("function" != typeof o && null !== o) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(o && o.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), o && a(e, o);
    }(y, o);
    var p,
      g,
      f,
      h = (p = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          o,
          r = i(y);
        if (p) {
          var t = i(this).constructor;
          o = Reflect.construct(r, arguments, t);
        } else o = r.apply(this, arguments);
        return (e = o) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : s(this);
      });
    function y() {
      var o;
      return !function (e, o) {
        if (!(e instanceof o)) throw TypeError("Cannot call a class as a function");
      }(this, y), o = h.apply(this, arguments), l(s(o), "draggedItem", void 0), l(s(o), "dragTarget", void 0), l(s(o), "droppedAtCoords", null), l(s(o), "container", e.createRef()), l(s(o), "scrollToDrop", function () {
        o.droppedAtCoords && (o.scrollBy(o.draggedItem.outerWrapper.current.getBoundingClientRect().top - o.droppedAtCoords.y + 35), o.droppedAtCoords = null);
      }), l(s(o), "scrollBy", function (e) {
        var o = r();
        return e ? (o.scrollTop += e, o.scrollTop < 0 ? 0 : o.scrollTop) : o.scrollTop;
      }), l(s(o), "handleSectionDragOver", function (e, r) {
        o.draggedItem && (o.dragTarget && o.dragTarget.unshiftForDrag(), e && (e.shiftForDrag(r), o.dragTarget = e), "function" == typeof o.props.onDragStart && o.props.onDragStart());
      }), l(s(o), "handleSectionDragStart", function (e) {
        o.draggedItem = e, o.dragTarget = null;
      }), l(s(o), "handleDragEnd", function () {
        o.dragTarget && o.dragTarget.unshiftForDrag(), "function" == typeof o.props.onDragEnd && o.props.onDragEnd(), o.dragTarget = null, o.draggedItem = null;
      }), l(s(o), "getMouseY", function (e) {
        return e.pageY - o.scrollBy();
      }), l(s(o), "getContainerRect", function () {
        return o.container.current.getBoundingClientRect();
      }), l(s(o), "handleBodyDrop", function (e) {
        if (o.draggedItem) {
          var r,
            t = o.getContainerRect(),
            n = o.getMouseY(e),
            s = o.draggedItem.props.id,
            u = o.dragTarget && o.dragTarget.props.id;
          o.droppedAtCoords = {
            y: n
          }, n >= t.bottom ? (u = o.refs["section" + (o.props.children.length - 1)].props.id, r = {
            dropAfter: !0
          }) : n < t.top && (u = o.refs.section0.props.id), d.isNil(s) || d.isNil(u) || s === u || o.props.onReorder(s, u, r), o.handleDragEnd(), o.draggedItem = null, e.preventDefault();
        }
      }), l(s(o), "handleBodyDragOver", function (e) {
        if (o.draggedItem) {
          var r = o.getContainerRect(),
            t = o.getMouseY(e);
          if (e.preventDefault(), t > r.bottom || t < r.top) {
            var n = t > r.bottom ? o.props.children.length - 1 : 0,
              d = o.refs["section" + n].getContainer();
            o.dragTarget && o.dragTarget.unshiftForDrag(), d.shiftForDrag(t > r.bottom), o.dragTarget = d;
          } else o.handleAutoScroll(t);
        }
      }), l(s(o), "handleAutoScroll", function (e) {
        e <= m ? o.scrollBy(-c) : e >= document.body.clientHeight - m && o.scrollBy(c);
      }), l(s(o), "getChild", function (e) {
        return o.refs["section" + e];
      }), o;
    }
    return g = [{
      key: "componentDidMount",
      value: function value() {
        this.draggedItem = null, this.dragTarget = null, this.handleAutoScroll = t(this.handleAutoScroll, 200), document.body.ondragover = this.handleBodyDragOver, document.body.ondrop = this.handleBodyDrop;
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        document.body.ondragover = null, document.body.ondrop = null;
      }
    }, {
      key: "render",
      value: function value() {
        return e.createElement("div", {
          ref: this.container,
          className: n("drag-drop-manager", this.props.className)
        }, e.Children.map(this.props.children, function (o, r) {
          return e.cloneElement(o, {
            onDragStart: this.handleSectionDragStart,
            onDragEnd: this.handleDragEnd,
            onDragOver: this.handleSectionDragOver,
            ref: "section" + r
          });
        }.bind(this)));
      }
    }], u(y.prototype, g), f && u(y, f), y;
  }(o);
l(p, "displayName", "DragDropManager");
export { c as AUTO_SCROLL_BY_PIXELS, m as AUTO_SCROLL_THRESHOLD_PIXELS, p as DragDropManager };